// Holds the short-lived MFA "step-up" token used to authorize destructive admin
// actions, plus a bridge so the axios interceptor can prompt the user (via the
// StepUpProvider dialog) when the backend returns 428 step_up_required.
let token = null;
let requester = null;

export const setStepUpToken = (t) => { token = t; };
export const getStepUpToken = () => token;
export const clearStepUpToken = () => { token = null; };

// The provider registers a function that opens the dialog and resolves once the
// user has entered a valid code (which stores a fresh token) or rejects on cancel.
export const setStepUpRequester = (fn) => { requester = fn; };
export const requestStepUp = () =>
  (requester ? requester() : Promise.reject(new Error("step-up unavailable")));
